$(document).ready(function(){
      // var devProductPriceValue = $('.product__price span[dataPriceIncrement="50"]').text();
      // devProductPriceValue = devProductPriceValue[1];
      // console.log(devProductPriceValue);
      // value = '$50';     
      // var answer = parseInt(devProductPriceValue) + parseInt(value);
      // $('.product__price span[dataPriceIncrement="50"]').text(answer);

    $(document).on('click', '.product__page [data-popout-option]', function (e) {
      e.preventDefault();
    
      var $option = $(this);
      var $popout = $option.closest('.select-popout');
      var $toggleText = $popout.find('[data-popout-toggle-text]');
      var $input = $popout.find('[data-popout-input]');
    
      var fullText = $option.find('span').text().trim();
    
      $toggleText.text(fullText);
    
      var selectedValue = $option.data('value');
      $input.val(selectedValue);
    
      $popout.find('.select-popout__item').removeClass('is-active');
      $option.closest('li').addClass('is-active');
    });  
});


// Shopify format money helper function
(function () {
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision ?? 2;
    thousands = thousands ?? ",";
    decimal   = decimal ?? ".";

    if (isNaN(number) || number === null) return "0";

    const fixed = (number / 100).toFixed(precision);
    const parts = fixed.split(".");
    const dollars = parts[0].replace(
      /\B(?=(\d{3})+(?!\d))/g,
      thousands
    );
    const cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  window.Shopify = window.Shopify || {};

  window.Shopify.formatMoney = function (cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || theme.moneyFormat || "$";

    function formatValue(match, placeholder) {
      switch (placeholder) {
        case "amount":
          return formatWithDelimiters(cents, 2);

        case "amount_no_decimals":
          return formatWithDelimiters(cents, 0);

        case "amount_with_comma_separator":
          return formatWithDelimiters(cents, 2, ".", ",");

        case "amount_with_space_separator":
          return formatWithDelimiters(cents, 2, " ", ".");

        case "amount_with_apostrophe_separator":
          return formatWithDelimiters(cents, 2, "'", ".");

        default:
          return formatWithDelimiters(cents, 2);
      }
    }

    return formatString.replace(placeholderRegex, formatValue);
  };
})();


// zepto pplr price update
function pplrPriceUpdate() {
 if(Shopify && typeof Shopify.formatMoney === 'function') {
    const productPriceElms = document.querySelectorAll('[data-product-price]');
    if(!productPriceElms.length || typeof pplr_product === 'undefined') {
      productPriceElms?.forEach(elm => elm.classList.remove('hidden')); // if pplr failed then show product price
      return;
    };

    let totalCents = 0;

    function calcPPLRPrices() {
      totalCents = 0;
      // Calculate total cents of inputs
      document.querySelectorAll('.pplr_text[data-pplr_price]').forEach(elm => {
        let price = parseFloat(elm.dataset.pplr_price) || 0;

        // convert to cents
        let cents = Math.round(price * 100);
        totalCents += cents;
      });

      // Calculate total cents of select
      document.querySelectorAll('.pplr_select').forEach(elm => {
        let price = parseFloat(elm[elm.selectedIndex].dataset.pplr_price) || 0;

        // convert to cents
        let cents = Math.round(price * 100);
        totalCents += cents;
      })
    }
    
    function updateMainPrice() {
      calcPPLRPrices();
      productPriceElms.forEach(elm => {
        elm.innerHTML = Shopify.formatMoney((pplr_product.price + totalCents), theme.moneyFormat);
        elm.classList.remove('hidden');
        elm.setAttribute('data-pplr-main-price', Shopify.formatMoney((pplr_product.price + totalCents), theme.moneyFormat));
      })
    }
    updateMainPrice();

    // For empty input value set it to default price
    document.querySelectorAll('.pplr_text[data-pplr_price]')?.forEach(elm => {
      elm.addEventListener('input', () => {
        if (elm.value.length === 0) {
          productPriceElms.forEach(priceElm => priceElm.classList.add('hidden'));
          setTimeout(() => {
            updateMainPrice();
          }, 400);
        }
      })
    })


    // Update prices when select value changes and all text inputs have no letters
    document.querySelectorAll('.pplr_select')?.forEach(elm => {
      elm.addEventListener('change', () => {
        if(productPriceElms.length && Array.from(document.querySelectorAll('.pplr_text[data-pplr_price]')).every(elm => elm.value.length === 0)) {
          productPriceElms.forEach(priceElm => priceElm.classList.add('hidden'));
          setTimeout(() => {
            updateMainPrice();
          }, 400);
        }
      })
    })
  }
}

window.addEventListener('pplrAppInitiated' , function() {
 pplrPriceUpdate();

  // On pplr swatch click - update prices
  document.querySelectorAll('.pplr-swatch-element')?.forEach(elm => {
    const productPriceElms = document.querySelectorAll('[data-product-price]');
    elm.addEventListener('click', () => {
      const isInputsEmtpy = [...document.querySelectorAll('.pplr_text')].every(elm => elm.value.length === 0);
      if(isInputsEmtpy) {
        productPriceElms?.forEach(priceElm => {
          if(priceElm.hasAttribute('data-pplr-main-price')) priceElm.innerHTML = priceElm.getAttribute('data-pplr-main-price');
        })
      }
    })
  })
})

// If no zepto pplr product options then show product prices
document.addEventListener('DOMContentLoaded', () => {
  if(typeof pplr_product === 'undefined') {
    const productPriceElms = document.querySelectorAll('[data-product-price]');
    if(!productPriceElms.length || typeof pplr_product === 'undefined') {
      // if price elements exists then remove hidden class
      productPriceElms?.forEach(elm => elm.classList.remove('hidden'));
    };
  }
})